import { collabora } from './collabora';
export default collabora;